import LocalisationEtStatut from './localisationEtStatut';
import MachineImageActions from './machineImageActions';
import ChiffreClePart from './chiffreClePart';
import ModeEtConsigne from './modeEtConsigne';
import { Box, Grid } from '@mui/material';
import Equipment from './equipment';
import Risk from './risk';
import '../../../../css/machines/readDonneGeneral.css';

const ReadDonneGeneralTab = () => {
  return (
    <Grid container spacing={3} className='read_donne_general_main_grid'>
      <Grid item xs={12} md={4} padding={3}>
        <Box className='read_donne_general_image_chiffre_box'>
          <MachineImageActions />
          <ChiffreClePart />
          <Risk />
          <Equipment />
        </Box>
      </Grid>
      <Grid item xs={12} md={8} padding={3}>
        <Box className='read_donne_general_second_grid_box'>
          <LocalisationEtStatut />
          <ModeEtConsigne />
        </Box>
      </Grid>
    </Grid>
  );
}

export default ReadDonneGeneralTab;